import {
  requestMagicLink as backendRequestMagicLink,
  type RequestMagicLinkResponse,
} from '@lms/api-client/backend';

// Thin wrapper around the backend magic-link endpoint. In the Next app this
// lived in a server action (features/auth/actions.ts); the SPA calls it
// directly from the login form and handles navigation client-side.
export function requestMagicLink(params: {
  email: string;
  slug: string;
  language?: string;
}): Promise<RequestMagicLinkResponse> {
  return backendRequestMagicLink(params);
}
